import type { SuretyAccount } from "@portal/api/account";
import { BondRequest, useReopenBondRequest } from "@portal/api/bond-request/agent";
import { ConfirmationModalClickWrapper } from "@portal/components/layout/ConfirmationModalClickWrapper";
import { LoadingModal } from "@portal/components/layout/LoadingModal";
import { Modal } from "@portal/components/layout/Modal";
import { Button } from "@portal/components/ui/Button";
import { MutationErrorFlag } from "@portal/components/ui/MutationErrorFlag";
import { HiOutlineFolderOpen } from "react-icons/hi2";
import { BondRequestLayout } from "../../../../shared/request/BondRequestLayout";

type ClosedBondRequestViewProps = {
	request: BondRequest;
	account: SuretyAccount;
};

export const ClosedBondRequestView = ({ request, account }: ClosedBondRequestViewProps) => {
	const {
		reopenBondRequest,
		reopenBondRequestError,
		reopenBondRequestLoading,
		dismissReopenBondRequestError,
	} = useReopenBondRequest(request.id, request.suretyAccountId);

	return (
		<>
			<BondRequestLayout
				request={request}
				account={account}
				actionButtons={
					<div className="flex items-center flex-col space-y-[4px] select-none">
						<ConfirmationModalClickWrapper
							className="items-center"
							message="Are you sure you want to reopen this bond request?"
							onConfirm={reopenBondRequest}
							confirmTrackingId="bond-request-agent-reopen-confirm"
							cancelTrackingId="bond-request-agent-reopen-cancel"
						>
							<Button
								color="primary"
								filled
								className="w-full flex items-center gap-x-[8px]"
								trackingId="bond-request-agent-reopen"
							>
								<HiOutlineFolderOpen size={16} />
								<span>Reopen Bond Request</span>
							</Button>
						</ConfirmationModalClickWrapper>
					</div>
				}
				termsAndConditionsOpen={false}
			/>
			{reopenBondRequestLoading && (
				<Modal>
					<LoadingModal />
				</Modal>
			)}
			<MutationErrorFlag
				mutationError={reopenBondRequestError}
				dismissError={dismissReopenBondRequestError}
			/>
		</>
	);
};
